import {SvgIcon, SvgIconProps} from "@mui/material";

export const TriangleShapeIcon: React.FC<SvgIconProps> = (props) => (
    <SvgIcon {...props} viewBox="0 0 24 24">
        <path
            d="M12 4 21 20H3L12 4z"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinejoin="round"
        />
    </SvgIcon>
);
